import { makeStyles } from '@material-ui/core'
import InfoIcon from '@mui/icons-material/Info'
import LoadingModal from 'src/components/common/LoadingModal'
import Button from '@mui/material/Button'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { COLORS } from 'src/utils/Themes/colors'
import { SAMPLE_LIFE_QUICK_QUOTE_DETAILS } from 'src/utils/constants/BuyPolicyLife'
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded'
import { useHistory } from 'react-router-dom'

const LifePriceDetails = () => {
  const classes = useStyles()
  const loading = false
  const history = useHistory()

  const handleProceed = () => {
    history.push(
      '/individual/dashboard/buyPolicy/life/insuranceDetails/terms-and-conditions'
    )
  }

  const showUpdatedText = () => {
    return false
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.quoteContainer}>
          <div className={classes.quoteSection}>
            <div>
              <img
                src={SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.providerImage}
                alt='providerImage'
                className={classes.digitImage}
              />
              <div>
                <span className={classes.digitInput}>
                  {SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.providerName}
                </span>
              </div>
            </div>
            <div>
              <span className={classes.digitOtherInput}>
                {SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.insuranceName}
              </span>
            </div>
          </div>
          <div className={classes.coverSection}>
            <span className={classes.digitCoverRate}>Cover:&nbsp;&nbsp;</span>
            <span className={classes.digitCoverRate}>
              <b>{formatToINR(SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.sumInsured)}</b>
            </span>
          </div>
          <div className={classes.quoteSection}>
            <span className={classes.digitBaseInput}>
              <div className={classes.tenureSelectContainer}>
                <span>Base Premium - </span>
              </div>
            </span>
            <span className={classes.digitRate}>
              {formatToINR(
                SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.basePremiumAmount ??
                  SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.premiumAmount
              )}
            </span>
          </div>
          {SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.discountAmount ? (
            <div className={classes.quoteSection}>
              <span className={classes.digitBaseInput}>Discount</span>
              <span className={classes.digitRate}>
                -&nbsp;
                {formatToINR(SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.discountAmount)}
              </span>
            </div>
          ) : null}

          {SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.totalTaxAmount ? (
            <div className={classes.quoteSection}>
              <span className={classes.digitBaseInput}>Tax</span>
              <span className={classes.digitRate}>
                {formatToINR(SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.totalTaxAmount)}
              </span>
            </div>
          ) : null}
        </div>
        <div className={classes.totalPremium}>
          <div className={classes.premiuSubTitle}>Total Premium</div>
          <div className={classes.premiuSubTitle}>
            <span>
              {formatToINR(SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.premiumAmount)}
            </span>
          </div>
        </div>
        <div className={classes.monthlyPremium}>
          {/* <span className={classes.premiuMonthlySubTitle}>Monthly Premium :</span>*/}
          <span className={classes.premiuMonthlySubTitle}>
            {/* {formatToINR(SAMPLE_LIFE_QUICK_QUOTE_DETAILS?.premiumAmount / 12)}/month*/}
          </span>
        </div>
        {showUpdatedText() && (
          <span className={classes.updatedText}>
            <InfoIcon />
            Please note that quote details have been updated
          </span>
        )}
        <div className={classes.proceedButtonContainer}>
          <Button
            id='proceedButton'
            variant='contained'
            className={classes.proceedButton}
            onClick={handleProceed}
          >
            Proceed
            <DoubleArrowRoundedIcon />
          </Button>
        </div>
      </div>
    </>
  )
}

export default LifePriceDetails

const useStyles = makeStyles({
  mainContainer: {
    border: '1px',
    background: 'linear-gradient( #EF669B -900%, #FFFFFF 100%)',
    boxShadow: '0px 4px 4px 0px #00000040',
    padding: '30px 20px',
    borderRadius: '10px',
  },
  digitItems: {
    marginLeft: '11px',
    marginBottom: '20px',
  },
  digitImage: {
    width: '60px',
    marginBottom: '-5px',
  },
  digitInput: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    color: '#666666 ',
  },
  digitBaseInput: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    whiteSpace: 'nowrap',
  },

  digitOtherInput: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    display: 'flex',
    color: '#2BA6C8',
    flexDirection: 'row-reverse',
    fontWeight: '600',
  },
  digitCoverRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  digitInputRate: {
    marginBottom: '28px',
    marginLeft: '105px',
  },
  digitRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  totalPremium: {
    display: 'flex',
    border: '1px solid #EF669B',
    padding: '10px 20px',
    borderRadius: '10px',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  monthlyPremium: {
    display: 'flex',
    padding: '1px 20px',
    borderRadius: '10px',
    backgroundColor: 'white',
    justifyContent: 'right',
  },
  premiuSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  premiuMonthlySubTitle: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  premiumRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    marginLeft: '142px',
  },
  quoteSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '10px',
    alignItems: 'center',
  },
  coverSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '10px',
    borderBottom: '1px solid #D7D7D7',
  },
  updatedText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    gap: '5px',
    fontSize: '14px',
    opacity: '0.8',
    color: COLORS.DARK_PINK,
  },
  quoteContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '0px 20px',
  },
  proceedButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  },
  proceedButton: {
    backgroundColor: '#EF669B !important',
    height: '35px',
    width: '125px',
    padding: '5px 5px 4px 10px !important',
    borderRadius: '10px !important',
    fontSize: '14px !important',
    display: 'flex',
    justifyContent: 'space-between !important',
    alignItems: 'center',
    textTransform: 'none !important',
    '&:hover': {
      backgroundColor: '#EF669B !important',
    },
  },
  tenureSelectContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})
